// extracted by mini-css-extract-plugin
export default {"interstital":"Interstital_interstital__x5bh7"};